import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@/lib/seo";
import Contact from "@/pages/Contact";

export const Route = createFileRoute("/_site/contact")({
  head: () => ({
    ...seo({
      title: "Contact Us | Kodiak Structures & Exteriors - Free Estimate",
      description:
        "Contact Kodiak Structures & Exteriors for a free estimate on roofing, siding, windows and gutters anywhere in Minnesota.",
      path: "/contact",
    }),
  }),
  component: Contact,
});
